import * as types from '../constants'
import _ from 'lodash'
const initState = {
    feedNoti: [],
    feedNotiInf : {},
    count: 0,
    getNoti:{}
}

export default function(state = initState, action) {
    switch (action.type) {
        case types.GET_LIST_NOTIFICATION:
            action.payload.forEach(element => {
                if(!state.feedNoti.includes(element._id)){
                    state.feedNoti.push(element._id)
                }
                state.feedNotiInf[element._id] = element
            });
            return _.cloneDeep(state)
        case types.GET_COUNT_NOTIFICATION:
            state.count = action.payload
            return _.cloneDeep(state)
        break;
        case types.SEEN_ALL_NOTIFICATION:
            state = action.payload
            return _.cloneDeep(state)
        break;
        case types.GET_NOTIFICATION:
            state.getNoti = action.payload
            return _.cloneDeep(state)
        break;
        default:
            return state;
    }
}